import React, { useState, useEffect } from 'react'
import { Control } from 'react-redux-form'
import duckify, { singleDuck } from '../../utils/duckify'
import { customers } from '../../ducks'
import Placeholder from '../Placeholder';
import Select from 'react-select';

const CommunicationSelectControl = ({ allDucksReady, permissionsList, field, customer, ...props }) => {
  const [formDisabled, setFormDisbaled] = useState(false)

  useEffect(() => {
    if (!field.editable) {
      setFormDisbaled(false)
      setTimeout(() => setFormDisbaled(field.fromSendEmail != null && field.fromSendEmail != ''), 200)
    }
  }, [field])

  return (
    <Placeholder.loading ready={allDucksReady}>
      <div className="permissions">
        {
          <Control.select
            component={Select}
            model=".permissions[]"
            disabled={formDisabled}
            mapProps={{
              onChange: ({ onChange }) => selected => (onChange(selected.map(s => s.value))),
              value: ({ modelValue = field.permissions || [] }) => modelValue.map(mv => (
                { value: mv, label: customer.individual_items_permissions_list.find(permission => permission.value == mv).name }
              )),
            }}
            multi
            options={customer.individual_items_permissions_list.map(t => ({ value: t.value, label: t.name }))}
            {...props}
          />
        }
      </div>
    </Placeholder.loading>
  )
}

const mapDucksToProps = () => {
  const customer = singleDuck(customers, 'current')

  return {
    customer,
  }
}

export default duckify(mapDucksToProps)(CommunicationSelectControl)
